module.exports = __webpack_public_path__ + "src/images/measurements/thighCurve.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/thighCurve.jpg
// module id = 1159
// module chunks = 0